 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"chat":"chat","social":"social","deviceManagement":"deviceManagement","event":"event","admin":"admin","aliBey":"aliBey","user":"user","HomeNew.vue":"HomeNew.vue","dashboard":"dashboard","workouts":"workouts","habit~nutrition":"habit~nutrition","nutrition":"nutrition","einmalig":"einmalig","habit":"habit","shop":"shop","gf":"gf","contract-v2":"contract-v2","contract-workspace-public~contract-workspace-v2":"contract-workspace-public~contract-workspace-v2","contract-workspace-public":"contract-workspace-public","contract-workspace-v2":"contract-workspace-v2","friends":"friends","live-quiz":"live-quiz","live-quiz-host":"live-quiz-host","live-quiz-manage":"live-quiz-manage","payment":"payment","pos-workspace":"pos-workspace","redirection":"redirection","trainerpoint-live":"trainerpoint-live"}[chunkId]||chunkId) + "." + {"chat":"059b32bf","chunk-04a70578":"7a4c6ee1","chunk-0637e8e6":"14cf4f78","chunk-0097edb9":"c3864d9c","chunk-0a6a27fb":"24f9d24b","chunk-152ca0f0":"fa24ae96","chunk-1a7d3fee":"34b119e6","chunk-1c81a122":"4b361acc","chunk-1d1be0ba":"a913533e","chunk-1e90651e":"9cf00be5","chunk-1fb712dd":"67eeffca","chunk-515fb775":"7927bbdf","chunk-48570ff6":"22358379","social":"5d808e3e","deviceManagement":"8d8ebc35","event":"2f278fed","chunk-217be9fa":"4eed72a2","admin":"e86eb0dd","aliBey":"2b98c1f7","chunk-2d216f56":"5478984d","chunk-f03f81fa":"1afeb322","chunk-3e996c88":"da82087a","user":"51afc336","chunk-e155fa78":"df34cf1b","chunk-632d68f8":"1bd7ddf5","chunk-9a0ba14e":"47be1e24","HomeNew.vue":"1b8537ce","chunk-2fa6c09f":"00efb6d9","chunk-3ef0055f":"5745d6a8","chunk-585b4c48":"7f754849","chunk-5e68a3aa":"5653193d","chunk-b067410a":"3dc4a508","chunk-ef2249dc":"92d13441","chunk-fda3fe0e":"14cbf717","chunk-1f729f17":"5d39df70","dashboard":"9d374639","workouts":"62d6b9f2","chunk-35408208":"269bf65e","chunk-6f564565":"608cb199","habit~nutrition":"f177cb18","nutrition":"3e11819c","einmalig":"f389d2a9","habit":"83096d28","chunk-28d824b1":"9f0f9438","chunk-2d0abe58":"cb79b1c2","chunk-2d0ae56b":"da7c86ae","chunk-2d0dda10":"fc094788","chunk-23bef907":"433157ef","shop":"81790f9e","chunk-32d00dc6":"b18dbf46","chunk-35f42bac":"b9cea346","chunk-37feaa88":"b6bcff6f","chunk-3cc16930":"8090d8e1","chunk-3e175f3a":"0d192ad2","chunk-407b1307":"de4ea883","chunk-40f278fa":"398401e9","chunk-421cf38f":"ffff4deb","chunk-b75f22a4":"02c3d7b1","chunk-520d2402":"39906495","gf":"3a1ef15a","chunk-5dff41d6":"a262f87b","chunk-5f11753e":"148c9f39","chunk-613e6a72":"adb86489","chunk-6465c5fc":"8002b935","chunk-67a1b969":"f9465f0f","chunk-6f11e604":"d15ea2e8","chunk-726839ae":"ebddc9fe","chunk-72a10981":"15541cfc","chunk-77b5d08c":"d773c817","chunk-8015e132":"72190d25","chunk-af37c6fe":"f6de2935","chunk-d50be17a":"6316bdde","chunk-d5fa2cb6":"c18a1465","chunk-d8c05fc2":"7deee348","chunk-2fd5f4cb":"7c6ed09e","chunk-40e6301c":"44706d94","chunk-a775c818":"4c2a8648","chunk-718bd655":"3a02697e","chunk-d67754f2":"4224ebca","chunk-2f488908":"5f181891","chunk-f88a8414":"e6524e7c","chunk-fc88f27c":"3889d9d4","chunk-1447a746":"d36378f0","chunk-1a812538":"2850cafe","chunk-206f08f9":"35218474","chunk-4cf70380":"87569c43","chunk-505b5877":"c1af32f0","chunk-546419d5":"a8dfbce9","chunk-7d2c1ac7":"1b8758cd","chunk-94e14e52":"e685ba57","chunk-9826f532":"984dd2bb","chunk-6a994f80":"f5e38f05","chunk-dd75b2f0":"06dff6df","chunk-aca64e18":"e222f92d","contract-v2":"f3aed8f3","contract-workspace-public~contract-workspace-v2":"1bf42ec7","contract-workspace-public":"92364764","contract-workspace-v2":"b50b01a9","friends":"4a8c5cfc","live-quiz":"3ad67d99","live-quiz-host":"47737ef3","live-quiz-manage":"2eb5ba0c","payment":"09903989","pos-workspace":"8e43fe56","redirection":"3acbed28","chunk-816d4dc0":"312f9ed4","chunk-2d216214":"1cff4ebd","chunk-2d216257":"58872a85","chunk-ee1fea50":"a4aafb0a","chunk-2d0c13c4":"7813a997","chunk-2d209639":"94c15c44","trainerpoint-live":"68e70a16"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chat":1,"chunk-04a70578":1,"chunk-0637e8e6":1,"chunk-0097edb9":1,"chunk-0a6a27fb":1,"chunk-152ca0f0":1,"chunk-1a7d3fee":1,"chunk-1c81a122":1,"chunk-1d1be0ba":1,"chunk-1e90651e":1,"chunk-1fb712dd":1,"chunk-515fb775":1,"social":1,"deviceManagement":1,"event":1,"chunk-217be9fa":1,"admin":1,"aliBey":1,"chunk-f03f81fa":1,"chunk-3e996c88":1,"user":1,"chunk-e155fa78":1,"chunk-632d68f8":1,"chunk-9a0ba14e":1,"HomeNew.vue":1,"chunk-2fa6c09f":1,"chunk-3ef0055f":1,"chunk-5e68a3aa":1,"chunk-b067410a":1,"chunk-ef2249dc":1,"chunk-fda3fe0e":1,"chunk-1f729f17":1,"dashboard":1,"workouts":1,"chunk-35408208":1,"chunk-6f564565":1,"habit~nutrition":1,"nutrition":1,"einmalig":1,"habit":1,"chunk-28d824b1":1,"shop":1,"chunk-32d00dc6":1,"chunk-35f42bac":1,"chunk-37feaa88":1,"chunk-3cc16930":1,"chunk-3e175f3a":1,"chunk-407b1307":1,"chunk-40f278fa":1,"chunk-421cf38f":1,"chunk-b75f22a4":1,"chunk-520d2402":1,"gf":1,"chunk-5dff41d6":1,"chunk-5f11753e":1,"chunk-613e6a72":1,"chunk-6465c5fc":1,"chunk-67a1b969":1,"chunk-6f11e604":1,"chunk-726839ae":1,"chunk-72a10981":1,"chunk-77b5d08c":1,"chunk-8015e132":1,"chunk-af37c6fe":1,"chunk-d50be17a":1,"chunk-d5fa2cb6":1,"chunk-d8c05fc2":1,"chunk-2fd5f4cb":1,"chunk-40e6301c":1,"chunk-a775c818":1,"chunk-718bd655":1,"chunk-d67754f2":1,"chunk-2f488908":1,"chunk-f88a8414":1,"chunk-fc88f27c":1,"chunk-1447a746":1,"chunk-1a812538":1,"chunk-206f08f9":1,"chunk-4cf70380":1,"chunk-505b5877":1,"chunk-546419d5":1,"chunk-94e14e52":1,"chunk-9826f532":1,"chunk-6a994f80":1,"chunk-dd75b2f0":1,"chunk-aca64e18":1,"contract-v2":1,"contract-workspace-public~contract-workspace-v2":1,"contract-workspace-public":1,"contract-workspace-v2":1,"friends":1,"live-quiz":1,"live-quiz-host":1,"live-quiz-manage":1,"pos-workspace":1,"chunk-816d4dc0":1,"trainerpoint-live":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"chat":"chat","social":"social","deviceManagement":"deviceManagement","event":"event","admin":"admin","aliBey":"aliBey","user":"user","HomeNew.vue":"HomeNew.vue","dashboard":"dashboard","workouts":"workouts","habit~nutrition":"habit~nutrition","nutrition":"nutrition","einmalig":"einmalig","habit":"habit","shop":"shop","gf":"gf","contract-v2":"contract-v2","contract-workspace-public~contract-workspace-v2":"contract-workspace-public~contract-workspace-v2","contract-workspace-public":"contract-workspace-public","contract-workspace-v2":"contract-workspace-v2","friends":"friends","live-quiz":"live-quiz","live-quiz-host":"live-quiz-host","live-quiz-manage":"live-quiz-manage","payment":"payment","pos-workspace":"pos-workspace","redirection":"redirection","trainerpoint-live":"trainerpoint-live"}[chunkId]||chunkId) + "." + {"chat":"4d234f46","chunk-04a70578":"d888e6e3","chunk-0637e8e6":"7e857e5e","chunk-0097edb9":"4eb0deb2","chunk-0a6a27fb":"9d1a0c6f","chunk-152ca0f0":"918eef6b","chunk-1a7d3fee":"1eeb5770","chunk-1c81a122":"f543d584","chunk-1d1be0ba":"83b48986","chunk-1e90651e":"f95702ee","chunk-1fb712dd":"66a1c861","chunk-515fb775":"aa93e336","chunk-48570ff6":"31d6cfe0","social":"d92bd277","deviceManagement":"23584837","event":"d8b22b17","chunk-217be9fa":"fd8c3217","admin":"4fd301a5","aliBey":"d5f8cca3","chunk-2d216f56":"31d6cfe0","chunk-f03f81fa":"350a1df7","chunk-3e996c88":"2ddcde3f","user":"189e5165","chunk-e155fa78":"a498c039","chunk-632d68f8":"d9fc8c5f","chunk-9a0ba14e":"fca5342d","HomeNew.vue":"ed169faa","chunk-2fa6c09f":"63f80147","chunk-3ef0055f":"ed0f3c30","chunk-585b4c48":"31d6cfe0","chunk-5e68a3aa":"9275210d","chunk-b067410a":"b4b6f499","chunk-ef2249dc":"38cdad1c","chunk-fda3fe0e":"dee56bdd","chunk-1f729f17":"881a3ba4","dashboard":"8d78e4bf","workouts":"6cf15cd0","chunk-35408208":"65727138","chunk-6f564565":"50798865","habit~nutrition":"551557c5","nutrition":"3f18c82e","einmalig":"507c392f","habit":"346ce143","chunk-28d824b1":"211ed81c","chunk-2d0abe58":"31d6cfe0","chunk-2d0ae56b":"31d6cfe0","chunk-2d0dda10":"31d6cfe0","chunk-23bef907":"31d6cfe0","shop":"b224513d","chunk-32d00dc6":"e345f5a8","chunk-35f42bac":"144faf14","chunk-37feaa88":"8111135b","chunk-3cc16930":"44380af7","chunk-3e175f3a":"4e463851","chunk-407b1307":"e5a7f67c","chunk-40f278fa":"9e01e709","chunk-421cf38f":"309c2516","chunk-b75f22a4":"80af7887","chunk-520d2402":"5956a1a3","gf":"4d79f104","chunk-5dff41d6":"0e3c4884","chunk-5f11753e":"f80acea5","chunk-613e6a72":"3fa4f906","chunk-6465c5fc":"9437412a","chunk-67a1b969":"25f3235e","chunk-6f11e604":"65a8f6a0","chunk-726839ae":"3fdd1937","chunk-72a10981":"253be585","chunk-77b5d08c":"7d12f124","chunk-8015e132":"c66fd981","chunk-af37c6fe":"069bc2f6","chunk-d50be17a":"5c500477","chunk-d5fa2cb6":"f65c00cc","chunk-d8c05fc2":"4be0704d","chunk-2fd5f4cb":"075303ba","chunk-40e6301c":"95582509","chunk-a775c818":"a88f345e","chunk-718bd655":"ee067e84","chunk-d67754f2":"f3091b54","chunk-2f488908":"d5745608","chunk-f88a8414":"79bf7a75","chunk-fc88f27c":"060afcca","chunk-1447a746":"c9fe281c","chunk-1a812538":"70f60110","chunk-206f08f9":"c740b4af","chunk-4cf70380":"d4a8c6a9","chunk-505b5877":"b0d8115f","chunk-546419d5":"39f7ca81","chunk-7d2c1ac7":"31d6cfe0","chunk-94e14e52":"2a59fb3e","chunk-9826f532":"1e86cea9","chunk-6a994f80":"f5a78ea6","chunk-dd75b2f0":"10395e6d","chunk-aca64e18":"454b8b08","contract-v2":"ff349b99","contract-workspace-public~contract-workspace-v2":"60d6f3a2","contract-workspace-public":"487a796a","contract-workspace-v2":"6d91e753","friends":"2d95a385","live-quiz":"eca3295c","live-quiz-host":"90fa3a4b","live-quiz-manage":"947660bf","payment":"31d6cfe0","pos-workspace":"ddb411cf","redirection":"31d6cfe0","chunk-816d4dc0":"022d1cd6","chunk-2d216214":"31d6cfe0","chunk-2d216257":"31d6cfe0","chunk-ee1fea50":"31d6cfe0","chunk-2d0c13c4":"31d6cfe0","chunk-2d209639":"31d6cfe0","trainerpoint-live":"1fb51549"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
